module.exports = __webpack_public_path__ + "static/media/zd-v5-arrow-right.aa8da2af.svg";